import { Switch } from "antd";
import Edit from "../../assets/Edit";
import Delete from "../../assets/Delete";

const upgradePlansColumns = ({
  setSelectedPlan,
  setNewStatus,
  setIsConfirmOpen,
  GlobalTooltip,
  openEditModal,
  isDeleteLoading,
  setIsDeleteOpen,
}) => [
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (value) => `₹ ${value}`,
  },
  {
    title: "No of Users",
    dataIndex: "no_of_users",
    key: "no_of_users",
  },
  {
    title: "Duration (in months)",
    dataIndex: "duration",
    key: "duration",
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (_, record) => (
      <Switch
        checked={record.status === "active"}
        checkedChildren="Active"
        unCheckedChildren="Inactive"
        onChange={(checked) => {
          setSelectedPlan(record);
          setNewStatus(checked ? "active" : "inactive");
          setIsConfirmOpen(true);
        }}
      />
    ),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "Actions",
    key: "actions",
    render: (_, record) => (
      <div className="flex gap-2">
        <GlobalTooltip title="Edit Upgrade Plan">
          <button onClick={() => openEditModal(record)}>
            <Edit />
          </button>
        </GlobalTooltip>
        <GlobalTooltip title="Delete Upgrade Plan">
          <button
            disabled={isDeleteLoading}
            onClick={() => {
              setSelectedPlan(record);
              setIsDeleteOpen(true);
            }}
          >
            <Delete />
          </button>
        </GlobalTooltip>
      </div>
    ),
  },
];

export default upgradePlansColumns;
